export default __webpack_public_path__ + "static/media/3.29b995ab.jpeg";